/*                                          */

import { COMMENT_NODE } from '#client/constants';
import {
	HYDRATION_END,
	HYDRATION_ERROR,
	HYDRATION_START,
	HYDRATION_START_ELSE
} from '../../../constants.js';
import * as w from '../warnings.js';
import { get_next_sibling } from './operations.js';

/**
 *
 *
 */
export let hydrating = false;

/*                         */
export function set_hydrating(value) {
	hydrating = value;
}

/**
 *
 *
 *
 *
 *
 */
export let hydrate_node;

/*                             */
export function set_hydrate_node(node) {
	if (node === null) {
		w.hydration_mismatch();
		throw HYDRATION_ERROR;
	}

	return (hydrate_node = node);
}

export function hydrate_next() {
	return set_hydrate_node(/*                       */ (get_next_sibling(hydrate_node)));
}

/*                             */
export function reset(node) {
	if (!hydrating) return;

	/*                                                           */
	if (get_next_sibling(hydrate_node) !== null) {
		w.hydration_mismatch();
		throw HYDRATION_ERROR;
	}

	hydrate_node = node;
}

/**
 *
 */
export function hydrate_template(template) {
	if (hydrating) {
		/*                                                                                     */
		hydrate_node = template.content;
	}
}

export function next(count = 1) {
	if (hydrating) {
		var i = count;
		var node = hydrate_node;

		while (i--) {
			node = /*                       */ (get_next_sibling(node));
		}

		hydrate_node = node;
	}
}

/**
 *
 */
export function remove_nodes() {
	var depth = 0;
	var node = hydrate_node;

	while (true) {
		if (node.nodeType === COMMENT_NODE) {
			var data = /*                  */ (node).data;

			if (data === HYDRATION_END) {
				if (depth === 0) return node;
				depth -= 1;
			} else if (data === HYDRATION_START || data === HYDRATION_START_ELSE) {
				depth += 1;
			}
		}

		var next = /*                       */ (get_next_sibling(node));
		node.remove();
		node = next;
	}
}

/**
 *
 *
 */
export function read_hydration_instruction(node) {
	if (!node || node.nodeType !== COMMENT_NODE) {
		w.hydration_mismatch();
		throw HYDRATION_ERROR;
	}

	return /*                  */ (node).data;
}
